(function () {
  const BLOCK_SELECTOR = '.tuya-product-similar';
  const ITEM_SELECTOR = '.tuya-product-similar__item';
  const TRACK_SELECTOR = '.tuya-product-similar__items';
  const PREV_SELECTOR = '.tuya-product-similar__nav--prev';
  const NEXT_SELECTOR = '.tuya-product-similar__nav--next';

  function initBlock(block) {
    if (!block) return;

    const track = block.querySelector(TRACK_SELECTOR);
    const prevBtn = block.querySelector(PREV_SELECTOR);
    const nextBtn = block.querySelector(NEXT_SELECTOR);

    if (!track || !prevBtn || !nextBtn) return;

    function getScrollStep() {
      const firstItem = track.querySelector(ITEM_SELECTOR);
      if (!firstItem) return track.clientWidth;
      const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      return firstItem.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      
      if (maxScroll <= 2) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
        return;
      } else {
        prevBtn.style.removeProperty('display');
        nextBtn.style.removeProperty('display');
      }

      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 2;
    }

    function scrollPrev() {
      track.scrollBy({
        left: -getScrollStep(),
        behavior: 'smooth'
      });
    }

    function scrollNext() {
      track.scrollBy({
        left: getScrollStep(),
        behavior: 'smooth'
      });
    }

    prevBtn.addEventListener('click', scrollPrev);
    nextBtn.addEventListener('click', scrollNext);
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    window.addEventListener('load', updateButtons);

    // Initial check
    window.setTimeout(updateButtons, 100);
    window.setTimeout(updateButtons, 500); // Drugi strzał na wypadek opóźnienia fontów

    // Store cleanup on element in case of re-init
    block._cleanupSimilar = () => {
      prevBtn.removeEventListener('click', scrollPrev);
      nextBtn.removeEventListener('click', scrollNext);
      track.removeEventListener('scroll', updateButtons);
      window.removeEventListener('resize', updateButtons);
      window.removeEventListener('load', updateButtons);
    };
  }

  function initAll() {
    document.querySelectorAll(BLOCK_SELECTOR).forEach(block => {
      if (block._cleanupSimilar) {
        block._cleanupSimilar();
      }
      initBlock(block);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
